import axios from 'axios';

type Args = {
  key: string;
  readTime: number;
  entityType: 'lawyer' | 'lawFirm' | 'enterprise' | 'law' | 'jurisdiction';
};

export function reportReadEntity(args: Args) {
  return axios.post('/report_read', {
    key: args.key,
    readTime: args.readTime,
    type: args.entityType,
  });
}

export function reportReadDecision({
  key,
  readTime,
  userWaitTime,
  loadingTime,
  requestTime,
  lastActivity,
}: {
  key: string;
  readTime: number;
  userWaitTime: number;
  loadingTime: number;
  requestTime: number;
  lastActivity: string;
}) {
  return axios.post('/report_read', {
    key,
    readTime,
    type: 'decision',
    userWaitTime,
    loadingTime,
    requestTime,
    lastActivity,
  });
}
